var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "message-queue-confirmation"
  }, [_c('div', {
    staticClass: "message-queue-confirmation-tip"
  }, _vm._l(_vm.formattedTips, function (part, index) {
    return _c('span', {
      key: index
    }, [part.isNumber ? _c('span', {
      staticClass: "message-queue-confirmation-tip-number"
    }, [_vm._v(_vm._s(part.content))]) : _c('span', [_vm._v(_vm._s(part.content))])]);
  }), 0), !_vm.props.payload.status && !_vm.isConfirmed ? _c('div', {
    staticClass: "message-queue-confirmation-button",
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t('AIDesk.确认转人工')) + " ")]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }